import { ProductDetailProps, ProductDetailEditorProps } from './ProductDetail.types';

/**
 * 오류 객체를 문자열로 변환하는 함수
 */
export const errorToString = (err: any): string => {
  if (!err) return '';
  if (typeof err === 'string') return err;
  if (typeof err === 'object') {
    return err.message || JSON.stringify(err);
  }
  return String(err);
};

/**
 * 원본 props를 상품 상세 컴포넌트 props로 변환
 * @param originalProps 원본 props 객체
 * @returns 변환된 컴포넌트 props
 */
export function adaptProductDetailProps(originalProps: any): ProductDetailProps {
  // 기본값 설정
  const originalComponentProps = originalProps?.componentProps || {};
  const originalPathVariables = originalProps?.pathVariables || {};
  
  // 스타일 병합
  const style = {
    ...(originalProps?.style || {}),
  };

  // 클래스명 설정
  const className = originalProps?.className || '';

  // 컴포넌트 속성 처리
  const componentProps = {
    order: originalComponentProps?.order || '',
    none: originalComponentProps?.none || 'none',
    lg: originalComponentProps?.lg || 9,
    productId: originalComponentProps?.productId || 0,
    showDescriptionTab: originalComponentProps?.showDescriptionTab !== undefined 
      ? originalComponentProps.showDescriptionTab 
      : true,
    showReviewsTab: originalComponentProps?.showReviewsTab !== undefined 
      ? originalComponentProps.showReviewsTab 
      : true,
    showSpecificationTab: originalComponentProps?.showSpecificationTab !== undefined 
      ? originalComponentProps.showSpecificationTab 
      : true,
    showStock: originalComponentProps?.showStock !== undefined 
      ? originalComponentProps.showStock 
      : false,
    ...originalComponentProps
  };

  // 최종 props 구성
  const adaptedProps: ProductDetailProps = {
    id: originalProps?.id || '',
    style,
    className,
    componentProps,
    pathVariables: { ...originalPathVariables },
    isEditor: originalProps?.isEditor || false,
  };

  // 원본 속성 중 명시적으로 처리하지 않은 나머지 속성 복사
  const excludeKeys = ['id', 'style', 'className', 'componentProps', 'pathVariables', 'isEditor'];
  Object.keys(originalProps || {}).forEach(key => {
    if (!excludeKeys.includes(key)) {
      adaptedProps[key] = originalProps[key];
    }
  });

  return adaptedProps;
}

/**
 * 에디터용 props 변환 함수
 * @param originalProps 원본 props 객체
 * @returns 에디터 컴포넌트용 props
 */
export function adaptProductDetailEditorProps(originalProps: any): ProductDetailEditorProps {
  // 기본 props 변환
  const adaptedProps = adaptProductDetailProps(originalProps) as ProductDetailProps;
  
  // 에디터 관련 추가 props
  return {
    ...adaptedProps,
    isSelected: originalProps.isSelected || false,
    isPreview: originalProps.isPreview || false,
    viewMode: originalProps.viewMode || 'pc',
    updateComponent: originalProps.updateComponent || (() => {})
  };
} 